import React, {ChangeEvent, useState} from "react";
import * as styled from "../../components/generalForm/GeneralFormCompStyled";
import axios from "axios";
import {useForm} from "@mantine/form";
import {showNotification} from "@mantine/notifications";
import {Button, Checkbox, NumberInput, Select, Textarea, TextInput} from "@mantine/core";
import {Language} from "../../functions/CommonFunctions";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";

type GeneralFormCompProps = {
    title?: string;
    content?: boolean;
    textareaTitle?: string;
    textareaPlaceholder?: string;
    careerUpload?: boolean;
    children?: React.ReactNode;
    breadcrumb?: any[];
};

const changeWriting = (e: ChangeEvent<HTMLInputElement>) => {
    // console.log(e.target.value);
}

const relationships = ['Hiç Evlenmemiş', 'Boşanmış', 'Ayrı Yaşıyor', 'Eşini Kaybetmiş'];

const GeneralFormComp = (props: GeneralFormCompProps) => {

        const [checked, setChecked] = React.useState(true);

        const [relationship, setRelationship] = useState("");

        const setValidate = (validate: string, e: any) => {
            e.target.setCustomValidity(validate);
        }

        const submitForm = useForm({
            initialValues: {
                email: '',
                name: '',
                message: '',
                surname: '',
                ourName: '',
                ourSurname: '',
                phone: '',
            },
            validate: {
                email: value => (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(value) ? null : 'Geçersiz eposta adresi',
            }
        });

        const handleSubmit = async (values: any) => {

            axios.post('/api/web/submit-success-story', values)
                .then(function (response) {
                    showNotification({
                        title: `${Language('success_title')}`,
                        message: `${Language('success_story')}`,
                        color: 'teal',
                        autoClose: 5000,
                    });
                })
                .catch(function (error) {
                    showNotification({
                        title: `${Language('error_message_title')}`,
                        message: `${Language('error_message_story')}`,
                        color: 'red',
                        autoClose: 5000,
                    });
                });

            submitForm.setValues({
                email: '',
                name: '',
                message: '',
                surname: '',
                ourName: '',
                ourSurname: '',
                phone: '',
            });


        }

        return (
            <styled.GeneralFormContainer>
                <styled.GeneralFormRow className={'mb-0 desktop-hidden'}>
                    {props.children ? (
                        <styled.GeneralFormContent>
                            {props.children}
                        </styled.GeneralFormContent>
                    ) : null}
                </styled.GeneralFormRow>
                <styled.GeneralFormContentWrapper id={'view-position'}>
                    {props.breadcrumb && (
                        <GeneralBreadcrumb items={props.breadcrumb} colorProps={false} margin={true}
                                           className={'general-form'}/>
                    )}
                    {props.title && (
                        <styled.GeneralFormTitle>{props.title}</styled.GeneralFormTitle>
                    )}
                    {props.content && (
                        <styled.GeneralFormContent>
                            <styled.GeneralFormContentTitle>
                                Şimdi formu doldurun, hediyelerinizi gönderelim.
                            </styled.GeneralFormContentTitle>
                            <styled.GeneralFormContentText>
                                Başvuru koşulları: Çiftlerimizin hediyelerini teslim alabilmeleri için;
                                <ul style={{listStyle: 'decimal', paddingLeft: 20}}>
                                    <li>
                                        Evlilik cüzdanlarının kopyasını bize iletmeleri gerekmektedir.
                                    </li>
                                    <li>
                                        Hediyelerimiz aylık periyotlarla sahiplerine ulaştırılacaktır.
                                    </li>
                                </ul>
                            </styled.GeneralFormContentText>
                        </styled.GeneralFormContent>
                    )}
                </styled.GeneralFormContentWrapper>
                <styled.GeneralFormWrapper onSubmit={submitForm.onSubmit(values => handleSubmit(values))}>
                    <styled.GeneralFormRow>
                        <TextInput required label="İsim" className={'styled-input'} type={'text'}
                                   onInvalid={(e) => setValidate('Lütfen isminizi girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="İsminizi girin" {...submitForm.getInputProps('name')} />
                        <TextInput required className={'styled-input'}
                                   onInvalid={(e) => setValidate('Lütfen soyadınızı girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="Soyadınızı girin" {...submitForm.getInputProps('surname')} />
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <TextInput required label="Eşinizin ismi" className={'styled-input'}
                                   onInvalid={(e) => setValidate('Lütfen eşinizin ismini girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="Eşinizin ismini girin" {...submitForm.getInputProps('ourName')} />
                        <TextInput required className={'styled-input'}
                                   onInvalid={(e) => setValidate('Lütfen eşinizin soyadını girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="Eşinizin soyadını girin" {...submitForm.getInputProps('ourSurname')} />
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <NumberInput required label="Telefon numarası" className={'styled-input'} hideControls
                                     onInvalid={(e) => setValidate('Lütfen telefon numaranızı girin', e)}
                                     onInput={(e) => setValidate('', e)}
                                     placeholder="Telefon numaranızı girin" {...submitForm.getInputProps('phone')} />
                        <TextInput required label="Email" className={'styled-input'} type={'email'}
                                   error={'Lütfen geçerli bir email adresi girin'}
                                   onInvalid={(e) => setValidate('Lütfen geçerli bir email adresi girin', e)}
                                   onInput={(e) => setValidate('', e)}
                                   placeholder="
                                    Email adresinizi girin" {...submitForm.getInputProps('email')} />
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <div className="wrapper">
                            <div className={'about'}>{props.textareaTitle}</div>
                            <Textarea required className={'styled-input-textarea'}
                                      onInvalid={(e) => setValidate('Lütfen hikayenizi yazın', e)}
                                      onInput={(e) => setValidate('', e)}
                                      placeholder={`${props.textareaPlaceholder}`} {...submitForm.getInputProps('message')} />
                        </div>
                    </styled.GeneralFormRow>

                    <styled.GeneralFormSelect>
                        {/*<styled.GeneralFormSelectTitle>*/}
                        {/*    İlişki durumunuz*/}
                        {/*</styled.GeneralFormSelectTitle>*/}
                        {/*<styled.GeneralFormSelectWrapper>*/}
                        {/*    <Select data={relationships}*/}
                        {/*            className={'styled-select-input'}*/}
                        {/*            placeholder="Lütfen buradan seçin"*/}
                        {/*            rightSection={
                         <Image loading={'lazy'} width={22}
                                   height={9}
                                   sizes={'100vw'}
                                   style={{width: '22', height: '9'}}
                                   src={`/next/assets/images/career/career-arrow.svg`}
                                   alt={'Pembe Panjur'} title={'Pembe Panjur'}
                            />
                        }*/}
                        {/*            rightSectionWidth={65}*/}
                        {/*            right={10}*/}
                        {/*            styles={(theme) => ({*/}
                        {/*                rightSection: {pointerEvents: 'none'},*/}
                        {/*                item: {*/}
                        {/*                    color: '#000',*/}
                        {/*                    '&:hover': {*/}
                        {/*                        color: '#D2147D',*/}
                        {/*                    },*/}
                        {/*                },*/}
                        {/*                input: {*/}
                        {/*                    color: '#000',*/}
                        {/*                    backgroundColor: 'rgba(210, 20, 125, 0.05)',*/}
                        {/*                }*/}
                        {/*            })}*/}
                        {/*            transitionProps={{transition: 'pop-top-left', duration: 80, timingFunction: 'ease'}}*/}
                        {/*            {...submitForm.getInputProps('relationship')}/>*/}
                        {/*</styled.GeneralFormSelectWrapper>*/}

                        <styled.GeneralFormSelectCheckboxes>
                            <Checkbox
                                label="Gönderdiğim hikayenin soyad kullanmadan başarı hikayeleri sayfasında yayınlanmasına izin veriyorum."
                                color={'gray'}
                                size={'md'}
                                className={'styled-checkbox'}
                                {...submitForm.getInputProps('permission')}
                            />
                        </styled.GeneralFormSelectCheckboxes>
                        <styled.GeneralFormInformationPrivacy>
                            <ul>
                                <li>
                                    İletişim bilgileriniz gizli tutulacak ve izniniz olmadan yayınlanmayacaktır.
                                </li>
                            </ul>
                        </styled.GeneralFormInformationPrivacy>
                    </styled.GeneralFormSelect>
                    <styled.GeneralFormRow className={'mb-0'}>
                        <styled.GeneralFormLine
                            style={props.careerUpload ? {background: '#000'} : {background: 'rgba(0, 0, 0, 0.2)'}}/>
                    </styled.GeneralFormRow>
                    <styled.GeneralFormRow>
                        <Button type="submit"
                                uppercase={true}
                                className={'styled-button'}
                        >Hikayeni Gönder</Button>
                    </styled.GeneralFormRow>
                </styled.GeneralFormWrapper>


            </styled.GeneralFormContainer>
        )
    }
;

export default GeneralFormComp;
